import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AuthoritySelectComponent } from './authorityselect.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule
  ],
  declarations: [AuthoritySelectComponent]
})
export class AuthoritySelectModule { }



// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/pf.main/authorityselect/authorityselect.module.ts